import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router)

const routes = []

function pushRoutes(appRoutes) {
    if (!(appRoutes instanceof Array)) throw new Error("appRoutes should be an array.")
    appRoutes.forEach(route => {
        routes.push(route)
    })
}

function findRoute(arr, name) {
    for (var i = 0, len = arr.length; i < len; i++) {
        var t = arr[i];
        if (t.name === name) return t;
        else if (t.children && t.children.length > 0) {
            t = findRoute(t.children, name);
            if (t) return t;
        }
    }
    return null;
}

function findBy(arr, func) {
    const result = [];
    findCore(arr, result)
    function findCore(items, result) {
        items.forEach(item => {
            if (func(item)) result.push(item)
            if (item.children && item.children.length > 0) {
                findCore(item.children, result)
            }
        })
    }
    return result
}

const instance = new Router({
    mode: 'hash',
    linkActiveClass: 'link-class',
    scrollBehavior: () => ({ y: 0 }),
    routes: []
})

export default {
    routes,
    pushRoutes,
    findRoute,
    findBy,
    instance
}